import React, { Component } from "react";
import { addRoleSchema } from "../../../../schema/add-role";
import Inputlayer from "../../../../components/FormComponent/Input";
import Btable from "./../../../../components/FormComponent/bootstrapTable";
import networkList from "./../../../../constants/networkList";
import postService from "./../../../../services/httpService";
import userTrackService from "./../../../../services/usertrack-service";

import { Modal, Spin } from "antd";

const $ = require("jquery");

class Add_Role extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadding: false,
      formData: [],
      roleData: [],
      permissionsData: [],
    };
  }

  componentDidMount() {
    this.setState((state) => ({ loadding: true }));
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    let { slug } = this.props.match.params;
    const { viewRolePermissions } = networkList;
    switch (slug) {
      case "add-role":
        addRoleSchema["feilds"].map((feild, key) => {
          addRoleSchema["feilds"][key]["value"] = null;
          addRoleSchema["feilds"][key]["disable"] = false;
        });
        this.setState((state) => ({
          loadding: false,
          addText: "Add New Role",
          rid: rid,
          formData: addRoleSchema["feilds"],
        }));
        break;
      case "view-role":
        this.setState(
          (state) => ({
            loadding: true,
            addText: "View Role",
            rid: rid,
            formData: addRoleSchema["feilds"],
          }),
          () => {
            let Userlogobj = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "View Role Permissions - Request",
              date: new Date(),
              meta: { roleid: rid },
            };
            userTrackService(Userlogobj);
            postService(viewRolePermissions, "POST", {
              data: { roleid: rid },
            }).then((res) => {
              let Userlogobjres = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "View Role Permissions - Response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              if (res.status) {
                addRoleSchema["feilds"].map((feild, key) => {
                  if (feild["name"] === "role_name") {
                    addRoleSchema["feilds"][key]["value"] =
                      res.roledata["name"];
                    addRoleSchema["feilds"][key]["disable"] = true;
                    addRoleSchema["feilds"][key]["errors"] = [];
                    this.setState((state) => ({
                      rowName: res.roledata["name"],
                    }));
                  }
                });

                // this.setState((state) => ({ tbody: res.data[0], loadding: false }));

                this.setState({
                  loadding: false,
                  addText: "View Role",
                  role_data: res["roledata"],
                  formData: addRoleSchema["feilds"],
                });
              } else {
                this.setState((state) => ({ loadding: false }));
              }
            });
          }
        );
        break;
      case "edit-role":
        this.setState(
          (state) => ({
            loadding: true,
            addText: "Edit Role",
            rid: rid,
            formData: addRoleSchema["feilds"],
          }),
          () => {
            let Userlogobj = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Edit Role Permissions - Request",
              date: new Date(),
              meta: { roleid: rid },
            };
            userTrackService(Userlogobj);
            postService(viewRolePermissions, "POST", {
              data: { roleid: rid },
            }).then((res) => {
              let Userlogobjres = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "Edit Role Permissions - Response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              if (res.status) {
                addRoleSchema["feilds"].map((feild, key) => {
                  if (feild["name"] === "role_name") {
                    addRoleSchema["feilds"][key]["value"] =
                      res.roledata["name"];
                    addRoleSchema["feilds"][key]["disable"] = true;
                    addRoleSchema["feilds"][key]["errors"] = [];
                    this.setState((state) => ({
                      rowName: res.roledata["name"],
                    }));
                  }
                });

                this.setState({
                  loadding: false,
                  addText: "Edit Role",
                  role_data: res["roledata"],
                  formData: addRoleSchema["feilds"],
                });
              } else {
                this.setState((state) => ({ loadding: false }));
              }
            });
          }
        );
        break;
      default:
        this.setState((state) => ({ loadding: false }));
        break;
    }
    $(".card").css({
      height:
        $(window).outerHeight() -
        ($("header").outerHeight() + $(".breadCrums").outerHeight()),
    });
  }

  editfeilds(data) {
    this.setState((state) => ({ roleData: data.roledata }));
  }

  permissionsTablechange(evt) {

    const { menuList } = this.props;
    menuList.map((menu, key) => {
      if (menu["submenu"].length === 0) {
        if (evt["id"] === "edit") {
          evt = {
            id: "view",
            value: true,
            parrentMode: evt.parrentMode,
            parrentName: evt.parrentMode,
          };
        }
      }
    });
    this.setState((state) => ({ permissionsData: evt }));
  }

  inputChangedState(event) {
    console.clear();
   
    if (event.name === "role_name") {
      const { checkDuplicateRole } = networkList;
      postService(checkDuplicateRole, "POST", { rolename: event.value }).then(
        (res) => {
        
          if (res.data === "1") {
            this.state.formData.map((form, key) => {
              if (form["name"] === event["name"]) {
                this.state.formData[key]["errors"] = [];
                this.state.formData[key]["valid"] = false;
                this.state.formData[key]["value"] = null;
                this.state.formData[key]["errors"].push({
                  id: key,
                  message: "Role Name already exists",
                });
              }
            });
            this.setState({ rowName: null });
          } else {
            this.state.formData.map((form, key) => {
              if (form["name"] === event["name"]) {
                this.state.formData[key]["valid"] = true;
                this.state.formData[key]["value"] = event.value;
                this.state.formData[key]["errors"] = [];
              }
            });
            this.setState({ rowName: event.value });
          }
        }
      );
    }
  }

  addnewRole() {
    this.setState((state) => ({ loadding: true }));
    const { createNewRole, updateRole } = networkList;
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    let { slug } = this.props.match.params;

    let permissionData = this.state.permissionsData;
    permissionData.map((data, key) => {
      let submenuView = [];
      if (data.submenu.length === 0) {
        Object.keys(data.permissions).map((okey) => {
          if (
            data["permissions"][okey] === "0" ||
            data["permissions"][okey] === "1"
          ) {
            permissionData[key]["permissions"][okey] = false;
          }
        });
      }
      if (data.submenu.length !== 0) {
        data.submenu.map((smenu, skey) => {
          Object.keys(smenu.permissions).map((okey) => {
            if (
              smenu["permissions"][okey] === "0" ||
              smenu["permissions"][okey] === "1"
            ) {
              permissionData[key]["submenu"][skey]["permissions"][okey] = false;
            }
          });

          if (smenu["permissions"]["view"]) {
            submenuView.push(true);
          } else {
            submenuView.push(false);
          }
        });
        if (submenuView.includes(true)) {
          Object.keys(data.permissions).map((okey) => {
            if (
              data["permissions"][okey] === "0" ||
              data["permissions"][okey] === "1"
            ) {
              permissionData[key]["permissions"][okey] = true;
            }
          });
        } else {
          Object.keys(data.permissions).map((okey) => {
            if (
              data["permissions"][okey] === "0" ||
              data["permissions"][okey] === "1"
            ) {
              permissionData[key]["permissions"][okey] = false;
            }
          });
        }
      }
    });

    this.validateFormFeilds();

    if (
      this.state["rowName"] !== null &&
      this.state["rowName"] !== "" &&
      this.state["rowName"] !== undefined &&
      permissionData.length !== 0
    ) {
      let data = {
        role_name: this.state["rowName"],
        data: permissionData,
      };

    
      let This = this;
      switch (slug) {
        case "add-role":
          let Userlogobj = {
            user: JSON.parse(localStorage.getItem("user")),
            action: "Create New Role - Request",
            date: new Date(),
            meta: data,
          };
          userTrackService(Userlogobj);
          postService(createNewRole, "POST", { data: data }).then((res) => {
            let Userlogobjres = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Create New Role - Response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            if (res.status) {
              this.setState((state) => ({ loadding: false }));
              Modal.success({
                title: "Success message",
                content: "Role Created Successfully",
                onOk: function () {
                  This.props.history.push("/settings/roles");
                },
              });
            } else {
              this.setState((state) => ({ loadding: false }));
              Modal.error({
                title: "Error message",
                content: "Something went wrong. Please,try again later",
                onOk: function () {
                  window.scrollTo(0, 0);
                },
              });
            }
          });
          break;
        case "edit-role":
          data["role_id"] = rid;
          let Userlogobjup = {
            user: JSON.parse(localStorage.getItem("user")),
            action: "Update Role - Request",
            date: new Date(),
            meta: data,
          };
          userTrackService(Userlogobjup);
          postService(updateRole, "POST", { data: data }).then((res) => {
            let Userlogobjupres = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Update Role - Response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjupres);
            if (res.status) {
              this.setState((state) => ({ loadding: false }));
              Modal.success({
                title: "Success message",
                content: "Role Updated Successfully",
                onOk: function () {
                  This.props.history.push("/settings/roles");
                },
              });
            } else {
              this.setState((state) => ({ loadding: false }));
              Modal.error({
                title: "Error message",
                content: "Something went wrong. Please,try again later",
                onOk: function () {
                  window.scrollTo(0, 0);
                },
              });
            }
          });
          break;
        default:
          break;
      }
    } else {
      window.scrollTo(0, 0);
      this.setState((state) => ({ loadding: false }));
      if (
        permissionData.length === 0 &&
        this.state["rowName"] !== null &&
        this.state["rowName"] !== "" &&
        this.state["rowName"] !== undefined
      ) {
        Modal.error({
          title: "Error message",
          content: "Please fill any one permission",
          onOk: function () {
            window.scrollTo(0, 0);
          },
        });
      }
    }
  }

  validateFormFeilds() {
    this.state.formData.map((feild, key) => {
      if (feild["required"]) {
        if (feild["errors"].length === 0) {
          feild.rules.map((rule, rkey) => {
            if (typeof rule.test === "function") {
              if (
                feild["value"] !== null &&
                feild["value"] !== undefined &&
                rule.test(feild["value"])
              ) {
              } else {
                window.scrollTo(0, 0);
                this.state.formData[key]["errors"].push({
                  message: rule.message,
                });
              }
            }
          });
        }
      }
    });
    this.setState((state) => ({ date: new Date() }));
    //console.log('addrole validate',roleForm.feilds);
  }

  onCancel() {
    this.props.history.push("/settings/roles");
  }

  render() {
    let { formData, addText } = this.state;
    let { slug } = this.props.match.params;
    return (
      <div>
        <Spin spinning={this.state.loadding}>
          <div className="card">
            <div className="pt-3 pb-5 m-3">
              <h1 className="text-center text-capitalize text-heading mb-0">
                {addText}
              </h1>
              <div className="row pt-2 px-5 justify-content-center">
                {formData.map((feild, key) => {
                  if (feild.element === "input") {
                    return (
                      <div
                        className={`${
                          feild.className ? feild.className : "col"
                        } my-2 ${feild.name}`}
                        key={key}
                      >
                        <div className="clearfix">
                          <p className="data-label w-100 mb-1">{feild.text}</p>
                        </div>
                        <Inputlayer
                          {...this.state}
                          key={key}
                          feildData={feild}
                          onInputChanges={this.inputChangedState.bind(this)}
                        />
                      </div>
                    );
                  }
                })}
              </div>
              <div className="row pt-4 px-3 pb-2 align-items-end">
                {formData.map((feild, key) => {
                  if (feild.element === "table") {
                    return (
                      <Btable
                        className="role_table"
                        feild={feild}
                        {...this.props}
                        {...this.state}
                        editFeilds={this.editfeilds.bind(this)}
                        permissionsTablechange={this.permissionsTablechange.bind(
                          this
                        )}
                      />
                    );
                  }
                })}
              </div>
              <div className="row justify-content-center">
                {slug === "add-role" && (
                  <button
                    className="btn btn-success text-capitalize mr-3"
                    onClick={this.addnewRole.bind(this)}
                  >
                    Add Role
                  </button>
                )}
                {slug === "edit-role" && (
                  <button
                    className="btn btn-success text-capitalize mr-3"
                    onClick={this.addnewRole.bind(this)}
                  >
                    Update Role
                  </button>
                )}
                <button
                  className="btn btn-success btn-next text-capitalize"
                  onClick={this.onCancel.bind(this)}
                >
                  cancel
                </button>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}
export default Add_Role;
